import ApolloRootProvider from "./apolloRootProvider";

export default ApolloRootProvider;
